import { get, post, put } from "./api_helper"

const getList = (params) => get(`admin/production-summary/${params.year}/${params.month}`)


const ProductionSummaryAPI = {
  getList
}

export default ProductionSummaryAPI